import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type UploadRfpLanesFileParams = {
  uploadParams: {
    rfpId: string
    rateType: string
    file: File
  }
  config?: { signal: AbortSignal }
}

export type UploadRfpLanesFileFactoryDependencies = {
  proposalRepository: ProposalRepository
}

export function uploadRfpLanesFileFactory({
  proposalRepository,
}: UploadRfpLanesFileFactoryDependencies) {
  return async function uploadRfpLanes({ uploadParams, config }: UploadRfpLanesFileParams) {
    const uploadMethod = proposalRepository.uploadRfpLanesFileV2(uploadParams, config)

    try {
      return await uploadMethod
    } catch (error) {
      throw new Error('Failed to upload rate lanes file', { cause: error as Error })
    }
  }
}

export function uploadRfpLanesFile(uploadParams: UploadRfpLanesFileParams) {
  const httpClient = new HttpClient(API_URL)
  const proposalRepository = new ProposalRepository({ httpClient })
  const upload = uploadRfpLanesFileFactory({ proposalRepository })

  return upload(uploadParams)
}
